import {Alert, Button, Dialog, DialogActions} from '@mui/material';
import {bool, func, object} from 'prop-types';
import React, {useEffect} from 'react';
import QuotaManagerContent from './QuotaManagerContent.jsx';
import dimensions from '@app/styles/dimensions.js';

const QuotaManagerModal = ({open, onClose, collection}) => {
  useEffect(() => {
    if (!collection) {
      onClose();
    }
  }, [collection, onClose]);

  return (
    <Dialog
      open={open}
      fullScreen
      hideBackdrop
      disableEnforceFocus
      sx={{
        top: dimensions.topNav.height - 1,
        zIndex: theme => theme.zIndex.modal - 1,
      }}
    >
      <QuotaManagerContent collection={collection} onClose={onClose} />
      <DialogActions
        sx={{
          alignItems: 'center',
        }}
        disableSpacing
      >
        {!collection?.permissions.shared &&
          collection?.permissions.is_owner && (
            <Alert severity="info" variant="outlined">
              Reserving a private collection will automatically share it with
              your organization.
            </Alert>
          )}
        <Button
          variant="contained"
          onClick={onClose}
          size="large"
          sx={theme => ({
            width: 300,
            marginLeft: 'auto',
            backgroundColor: 'grey.200',
            color: theme.palette.getContrastText(theme.palette.grey[200]),
            '&:hover': {
              backgroundColor: 'grey.300',
              color: theme.palette.getContrastText(theme.palette.grey[300]),
            },
            ...theme.applyStyles('dark', {
              backgroundColor: 'grey.500',
              color: theme.palette.getContrastText(theme.palette.grey[500]),
              '&:hover': {
                backgroundColor: 'grey.600',
                color: theme.palette.getContrastText(theme.palette.grey[600]),
              },
            }),
          })}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

QuotaManagerModal.propTypes = {
  open: bool,
  collection: object,
  onClose: func,
};

export default QuotaManagerModal;
